<template lang="pug">
.receipt-item-chip
  v-chip(disabled)
    v-avatar.white--text(color="green") {{ year }}
    .detail {{ text }}
</template>
<script>
export default {
  name: "ReceiptItemChip",
  props: {
    year: {
      type: [String, Number],
      default: ""
    },
    text: {
      type: [String, Number],
      default: ""
    }
  }
};
</script>
